import { render, staticRenderFns } from "./Equipo.vue?vue&type=template&id=7822bb89&"
import script from "./Equipo.vue?vue&type=script&lang=js&"
export * from "./Equipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports